import React, { useEffect, useState } from "react";

import { LightskiEmbedder } from "@lightski/react";

import { fetchJwtToken } from "modules/Retention/services/retention";


const EmbedAnalytics = ({
  clientId='',
  embedId='',
  disabled=true
}) => {
  const [userJwt, setUserJwt] = useState(null);

  useEffect(() => {
    if (!disabled) {
      fetchJWTAsync();
    }
  }, [disabled]);

  /**
   * Fetches the JWT token.
   *
   * @returns {Promise}
   */
  const fetchJWTAsync = async () => {
    let response;

    try{
      response = await fetchJwtToken();
    } catch (error) {
      return { hasError: true, error };
    }

    setUserJwt(response?.result?.ligitskiJwt);
  }

  return (
    <>
      {!disabled && userJwt && (
        <LightskiEmbedder
          className="h-full w-full pt-12 pb-12 pr-16 pl-16"
          clientId={clientId}
          userJwt={userJwt}
          embedId={embedId}
        />
      )}
    </>
  );
}

export default EmbedAnalytics;
